/* eslint max-len: 0 */
import React from 'react';

export const Bookmark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="83" viewBox="0 0 56 83" fill="none">
    <path d="M0 0H56V83L28 66.4L0 83V0Z" fill="#202020" />
    <path
      d="M28 18L32.044 28.434L43.2169 29.0557L34.5433 36.126L37.4046 46.9443L28 40.88L18.5954 46.9443L21.4567 36.126L12.7831 29.0557L23.956 28.434L28 18Z"
      fill="#F9CB2A"
    />
  </svg>
);
